import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimit/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimit/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimit/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimit/slot-game/bin/asset/assettypes/SpineAsset";

export class FITH2GameAssets {
    public static BITMAP_FONT_WIN_COUNT_UP: string = "NumbersWinCountUp";
    public static BITMAP_FONT_WIN_WAYS: string = "NumbersWaysWon";
    public static BITMAP_FONT_WAYS: string = "NumbersWays";
    public static BITMAP_FONT_FS_SPINS: string = "NumbersFSSpins";
    public static BITMAP_FONT_FS_COIN_MULTI: string = "NumbersFSMulti";
    public static BITMAP_FONT_REEL_MULTI: string = "NumbersRMulti";

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],
        main: [
            {
                name: "fonts",
                assets: [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("NumbersWaysWon", "fonts/bitmapfonts/NumbersWaysWon.fnt"),
                    new BitmapFontAsset("NumbersWays", "fonts/bitmapfonts/NumbersWays.fnt"),
                    new BitmapFontAsset("NumbersFSMulti", "fonts/bitmapfonts/NumbersFSMulti.fnt"),
                    new BitmapFontAsset("NumbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset("NumbersFSSpins", "fonts/bitmapfonts/NumbersFSSpins.fnt"),
                    new BitmapFontAsset("NumbersRMulti", "fonts/bitmapfonts/NumbersRMulti.fnt")
                ]
            },
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json")
                ]
            },
            {
                name: "mainHigh",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("mainHigh0", "sheets/mainHigh/mainHigh0.json")
                ]
            },
            {
                name: "mainJpeg",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json"),
                    new TextureAsset("mainJpeg10", "sheets/mainJpeg/mainJpeg10.json"),
                    new TextureAsset("mainJpeg11", "sheets/mainJpeg/mainJpeg11.json"),
                    new TextureAsset("mainJpeg12", "sheets/mainJpeg/mainJpeg12.json"),
                    new TextureAsset("mainJpeg13", "sheets/mainJpeg/mainJpeg13.json"),
                    new TextureAsset("mainJpeg14", "sheets/mainJpeg/mainJpeg14.json"),
                    new TextureAsset("mainJpeg15", "sheets/mainJpeg/mainJpeg15.json"),
                    new TextureAsset("mainJpeg16", "sheets/mainJpeg/mainJpeg16.json"),
                    new TextureAsset("mainJpeg17", "sheets/mainJpeg/mainJpeg17.json")
			
                ],
                animations: {}
            },
            {
                name: "symbolsHighQuality",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbolsHighQuality0", "sheets/symbolsHighQuality/symbolsHighQuality0.json")
                ],
                animations: {
                    "D": "D/D",
                    "M_spin": "FS/FS_spin",
                    "GC_spin": "FS/FS_spin",
                    "BC_spin": "FS/FS_spin",
                    "D_spin": "D/D_spin",
                    "D_Bottom": "D/D_Bottom",
                    "D_Left": "D/D_Left",
                    "D_Top": "D/D_Top",
                    "D_Right": "D/D_Right",
                }
            },
            {
                name: "symbolsHighQualityJpeg",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbolsHighQualityJpeg0", "sheets/symbolsHighQualityJpeg/symbolsHighQualityJpeg0.json")
                ],
                animations: {}
            },
            {
                name: "noTinyPng",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("noTinyPng", "sheets/noTinyPng/noTinyPng0.json")
                ]
            },
            {
                name: "freespin",
                assets: [
                    new TextureAsset("freespin", "sheets/freespin/freespin0.json")
                ]
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("W", "spine/W.json"),
                    new SpineAsset("bigWinLv1", "spine/bigWinLv1.json"),
                    new SpineAsset("bigWinLv2", "spine/bigWinLv2.json"),
                    new SpineAsset("bigWinLv3", "spine/bigWinLv3.json"),
                    new SpineAsset("bigWinLv4", "spine/bigWinLv4.json"),
                    new SpineAsset("bigWinLv5", "spine/bigWinLv5.json"),
                    new SpineAsset("FS_background", "spine/FS_background.json"),
                    new SpineAsset("wagon", "spine/Wagon.json"),
                    new SpineAsset("coin", "spine/Hit.json"),
                    new SpineAsset("DY", "spine/DY0.json"),
                    new SpineAsset("DC", "spine/DC0.json"),
                    new SpineAsset("C", "spine/PC.json"),
                    new SpineAsset("R", "spine/R0.json"),
                    new SpineAsset("N", "spine/N.json"),
                    new SpineAsset("chest", "spine/chest.json"),
                    new SpineAsset("wildMining", "spine/WildMining.json"),
                    new SpineAsset("anticipation", "spine/anticipation.json"),
                    new SpineAsset("FS_Intro", "spine/FS_Intro.json"),
                    new SpineAsset("FS_Outro", "spine/FS_Outro.json"),
                    new SpineAsset("winCap", "spine/winCap.json"),
                    new SpineAsset("S", "spine/S.json"),
                    new SpineAsset("XS", "spine/X.json"),
                    new SpineAsset("upgrade", "spine/upgrade.json"),
                ]
            }
        ]
    };
}
